import Vue from 'vue'
import Router from 'vue-router'

// import WorkArt from '@/components/WorkArt'
import Filter from '@/components/Filter'
import Login from '@/components/users/Login'
import LinkLogin from '@/components/users/LinkLogin'
import ArtworkTypes from '@/components/codebooks/ArtworkTypes'
import Authors from '@/components/codebooks/Authors'
import Locations from '@/components/codebooks/Locations'
import Styles from '@/components/codebooks/Styles'
import Techniques from '@/components/codebooks/Techniques'
import Materials from '@/components/codebooks/Materials'
import Themes from '@/components/codebooks/Themes'

import ShareLinks from '@/components/shareLinks/ShareLinks'

import MyProfile from '@/components/users/MyProfile'

import ExportBoxes from '@/components/exports/ExportBoxes'
import ExportBoxContent from '@/components/exports/ExportBoxContent'
import ExportCreate from '@/components/exports/ExportCreate'
import ExportHistory from '@/components/exports/ExportHistory'

import ChangePassword from '@/components/users/ChangePassword'
import LocalSettings from '@/components/users/LocalSettings'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Filter',
      component: Filter
    },
    {
      path: '/Export/Create',
      name: 'ExportCreate',
      component: ExportCreate
    },
    {
      path: '/Export/BoxList',
      name: 'ExportBoxes',
      component: ExportBoxes
    },
    {
      path: '/Export/History',
      name: 'ExportHistory',
      component: ExportHistory
    },
    {
      path: '/Export/BoxContent',
      name: 'ExportBoxContent',
      component: ExportBoxContent
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/LinkLogin/:code/:link',
      name: 'LinkLogin',
      component: LinkLogin
    },
    {
      path: '/ArtworkTypes',
      name: 'ArtworkTypes',
      component: ArtworkTypes
    },
    {
      path: '/Authors',
      name: 'Authors',
      component: Authors
    },
    {
      path: '/Locations',
      name: 'Locations',
      component: Locations
    },
    {
      path: '/Styles',
      name: 'Styles',
      component: Styles
    },
    {
      path: '/Techniques',
      name: 'Techniques',
      component: Techniques
    },
    {
      path: '/Materials',
      name: 'Materials',
      component: Materials
    },
    {
      path: '/Themes',
      name: 'Themes',
      component: Themes
    },
    {
      path: '/MyProfile',
      name: 'MyProfile',
      component: MyProfile
    },
    {
      path: '/PasswordChange',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/ShareLinks',
      name: 'ShareLinks',
      component: ShareLinks
    },
    {
      path: '/LocalSettings',
      name: 'LocalSettings',
      component: LocalSettings
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js